import { Request } from "./Request";
import { Response } from "./Response";
export const fetch = create(globalThis.fetch);
fetch.create = create;
function create(fetch) {
    return async (request) => {
        const r = Request.create(request);
        return Response.from(await fetch(r.url.toString(), await Request.to(r)));
    };
}
//# sourceMappingURL=fetch.js.map